// TOP LEVEL IMPORTS
import React from 'react';
// import Truncate from 'react-truncate';
import map from 'lodash/map';
// ANTD
import Input from 'antd/lib/input';
import Checkbox from 'antd/lib/checkbox';
import Collapse from 'antd/lib/collapse';
import 'antd/lib/collapse/style/css';
import 'antd/lib/checkbox/style/css';
import SortableQuestions from './SortableQuestions';

// APOLLO
// COMPONENTS
import Body from 'components/text/Body';

export const CATEGORIES = [
  {
    key: 'Headshots',
    label: 'Headshots',
  },
  {
    key: 'Family Portraits',
    label: 'Family Portraits',
  },
  {
    key: 'Newborn',
    label: 'Newborn',
  },
  {
    key: 'Senior Portraits',
    label: 'Senior Portraits',
  },
  {
    key: 'Uncategorized',
    label: 'Uncategorized',
  },
  {
    key: 'Wedding',
    label: 'Wedding',
  },
  {
    key: 'Events',
    label: 'Events',
  },
  {
    key: 'Commercial',
    label: 'Commercial',
  },
  {
    key: 'Boudoir',
    label: 'Boudoir',
  },
];

const Panel = Collapse.Panel;

export class QuestionTemplateForm extends React.Component {
  getQuestionsByCategory = () => {
    const { questionOptions } = this.props;
    const catKeys = map(CATEGORIES, 'key');
    const questionsByCategory = [];

    catKeys.forEach((cat, index) => {
      const quests = [];

      questionOptions.forEach(({ title, categories }) => {
        if (categories && categories.length > 0 && categories.indexOf(cat) !== -1) {
          quests.push({ value: title, label: title });
        }
      });

      // Only display categories that have at least one question
      if (quests.length > 0) {
        questionsByCategory.push({
          category: CATEGORIES[index].label,
          questions: quests,
        });
      }
    });

    return questionsByCategory;
  };

  onChange = (e, q) => {
    if (e.target.checked) {
      let questions = [...this.props.selectedQuestions, q];
      this.props.onChange({ selectedQuestions: questions });
    } else {
      let questions = this.props.selectedQuestions.filter(selectedQuestion => selectedQuestion.value !== q.value);
      this.props.onChange({ selectedQuestions: questions });
    }
    // let questions = union(this.props.selectedQuestions, checkedValues);
    // let questions = [...this.props.selectedQuestions, ...checkedValues];
    // console.log('questions', questions);
    // this.props.onChange({ questions });
  };

  render() {
    if (this.props.step === 1) {
      return (
        <div>
          <div>
            <label>Template name</label>
            <Input
              size="large"
              value={this.props.title}
              onChange={e => this.props.onChange({ title: e.target.value })}
            />
          </div>
        </div>
      );
    }

    if (this.props.loadingQuestions) {
      return <div>loading questions...</div>;
    }

    if (this.props.step === 2) {
      const questionsByCategory = this.getQuestionsByCategory();

      return (
        <div>
          <div>
            <label>Choose Questions</label>
            <Collapse onChange={() => {}}>
              {questionsByCategory.map(({ category, questions }) => (
                <Panel header={category} key={category}>
                  {questions.map(q => (
                    <div key={q.label + q.value}>
                      <Checkbox
                        value={q.value}
                        checked={this.props.selectedQuestions.map(item => item.value).includes(q.value)}
                        label={q.label}
                        onChange={e => this.onChange(e, q)}
                      >
                        <Body>{q.label}</Body>
                      </Checkbox>
                    </div>
                  ))}
                </Panel>
              ))}
            </Collapse>
          </div>
        </div>
      );
    }

    if (this.props.step === 3) {
      return (
        <React.Fragment>
          <div style={{ padding: 10 }}>
            <Body>
              Last step. <br />
              You can re-order your questions by dragging and dropping below.
            </Body>
          </div>
          <SortableQuestions onChange={this.props.onChange} selectedQuestions={this.props.selectedQuestions} />
        </React.Fragment>
      );
    }
  }
}

QuestionTemplateForm.defaultProps = {
  selectedQuestions: [],
};

// STYLE
// ==========================================

// EXPORT
// ==========================================
export default QuestionTemplateForm;



// WEBPACK FOOTER //
// ./src/components/forms/QuestionTemplateForm/index.js